import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=4fb1235c&scoped=true&"
import script from "./AppSetting.vue?vue&type=script&lang=ts&"
export * from "./AppSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AppSetting.vue?vue&type=style&index=0&id=4fb1235c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1235c",
  null
  
)

export default component.exports